// services/clientService.ts
import { Client, BaseClient } from "../types/features/Client";
import { PaginatedResponse } from "../types/core/PaginatedResponse";
import { apiClient } from "../utils/apiClient";
import axios from "axios";

export const clientService = {
  async getClients(page: number = 1, perPage: number = 20): Promise<PaginatedResponse<Client>> {
    const response = await apiClient.get<PaginatedResponse<Client>>('/clients', {
      params: { page, per_page: perPage },
    });
    return response.data;
  },

  async getClientById(id: string): Promise<Client | null> {
    const response = await apiClient.get<Client>(`/clients/${id}`);
    return response.data;
  },

  async searchClientByPhone(phone: string): Promise<Client | null> {
    const response = await apiClient.get<Client>('/clients/search/by-phone', {
      params: { phone },
    });
    return response.data;
  },

  async searchClientByEmail(email: string): Promise<Client | null> {
    const response = await apiClient.get<Client>('/clients/search/by-email', {
      params: { email },
    });
    return response.data;
  },

  async searchClients(query: string, page: number = 1, perPage: number = 20): Promise<PaginatedResponse<Client>> {
    const response = await apiClient.get<PaginatedResponse<Client>>('/clients/search', {
      params: { q: query, page, per_page: perPage },
    });
    return response.data;
  },

  async createClient(client: Omit<Client, "id" | "created_at" | "updated_at">): Promise<Client> {
    const response = await apiClient.post<Client>('/clients', client);
    return response.data;
  },

  async updateClient(id: string, data: Partial<BaseClient>): Promise<Client> {
    const response = await apiClient.put<Client>(`/clients/${id}`, data);
    return response.data;
  },

  async getStats(): Promise<ClientStats> {
    const response = await apiClient.get<ClientStats>('/clients/stats');
    return response.data;
  },

  async getClientByUserId(userId: string): Promise<Client | null> {
    try {
      const response = await apiClient.get<Client>(`/clients/by-user/${userId}`);
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error) && error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  },

  async findOrCreateByUserId(data: {
    user_id: string;
    firstname?: string;
    lastname?: string;
    email?: string;
    phone?: string;
  }): Promise<Client> {
    const response = await apiClient.post<Client>('/clients/find-or-create-by-user', data);
    return response.data;
  },
};

export interface ClientStats {
  total: number;
  users: number;
  prospects: number;
}